import {
  AreaItemType,
  ConditionField,
  DimensionDescriptor,
  DimensionField,
  DimensionFieldType,
  FieldConfiguration,
  FieldConfigurationType,
  GroupingField,
  MeasureDescriptor,
  MeasureField,
  MetricDescriptor,
  MetricField,
  ReportField,
  SortField,
  TabularConfiguration,
  TabularGeneralSettings,
} from "../../../../../shared/reporting/api/biClient.types";
import { tabularGeneralSettingsSchema } from "../../../../../shared/reporting/api/biClientSchema";
import { isDimensionBasedType } from "../../../../../shared/reporting/utils/fieldsHelper.ts";
import cloneDeep from "../../../../../shared/utilities/cloneDeep";

export const createTabularReportConfiguration = (
  conditions: ConditionField[],
  fields: ReportField[],
  sorts: SortField[],
  grouping: GroupingField[],
  settings: TabularGeneralSettings
) => {
  const reportConfiguration: TabularConfiguration = {
    conditions: conditions.map((c) => c.config),
    fields: fields.map((field) => field.config),
    sort: sorts.map((s) => ({
      name: s.config.name,
      id: s.config.id,
      ordering: s.config.ordering,
      caption: s.config.caption,
    })),
    grouping: [...grouping],
    settings: { ...settings },
  };
  return reportConfiguration;
};

export const configurationToTabularFields = (
  configs: FieldConfiguration[],
  dimensions: DimensionDescriptor[],
  measures: MeasureDescriptor[],
  metrics: MetricDescriptor[]
) => {
  try {
    const tableFields = configs
      .map((config) => {
        if (isDimensionBasedType(config.type)) {
          const dimensionMeta = dimensions.find((d) => d.name === config.name);
          if (dimensionMeta) {
            return <DimensionField>{
              type: DimensionFieldType.DIMENSION,
              meta: dimensionMeta,
              config,
              areaItemType: AreaItemType.FIELDS,
            };
          } else {
            //eslint-disable-next-line no-console
            console.log(`Field ${config.name} is not found in the dimensions' list`);
            return undefined;
          }
        } else if (config.type === FieldConfigurationType.Measure || config.type === FieldConfigurationType.Irr) {
          const measure = measures.find((m) => m.name === config.name);
          if (measure) {
            return <MeasureField>{
              type: DimensionFieldType.MEASURE,
              meta: measure,
              areaItemType: AreaItemType.FIELDS,
              config,
            };
          } else {
            //eslint-disable-next-line no-console
            console.log(`Measure ${config.name} is not found in the measures' list`);
            return undefined;
          }
        }
        if (config.type === FieldConfigurationType.Metric) {
          const metric = metrics.find((m) => m.name === config.name);
          if (metric) {
            return <MetricField>{
              type: DimensionFieldType.METRIC,
              meta: metric,
              areaItemType: AreaItemType.FIELDS,
              config,
            };
          } else {
            //eslint-disable-next-line no-console
            console.log(`Metric ${config.name} is not found in the metrics' list`);
            return undefined;
          }
        }
        return undefined;
      })
      .filter((field): field is ReportField => !!field);
    return tableFields;
  } catch {
    return [];
  }
};

export const configurationToGrouping = (grouping: GroupingField[]) => {
  try {
    const groups = cloneDeep(grouping);
    return groups;
  } catch {
    return [];
  }
};

export const configurationToTabularSettings = (settings: TabularGeneralSettings) => {
  return tabularGeneralSettingsSchema.parse(settings);
};
